import styled from "styled-components";
import PlayVideoList from "./PlayVideoList";

const PlayPage = () => {
  return (
    <DivTest>
      <PlayVideoList />
    </DivTest>
  );
};

const DivTest = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  margin-left: 2rem;
`;

export default PlayPage;
